import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import GoBackButton from '../../../components/GoBackButton';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import { updateConstructionRegistrationSettings } from '../../../store/ducks/contracts-and-constructions/actions';
import {
  DEFAULT_DELIVERY_CONDITIONS,
  DEFAULT_RESPONSIBLE_OF_CONSTRUCTION
} from '../../../store/ducks/contracts-and-constructions/types';
import { ConstructionHeader } from '../styles';
import ConstructionRegistrationRoutes, {
  EConstructionRegistrationRoutes
} from './constructionRegistration.routes';
import { Title } from '@gerdau/hefesto/Title';
import ConstructionRegistrationTabs from './ConstructionRegistrationTabs';

const ConstructionRegistration: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const constructionRegistrationState = useSelector(
    (appState: ApplicationState) =>
      appState.contractsAndConstructions.constructionRegistration
  );

  const [constructionData, setConstructionData] = useState(
    constructionRegistrationState.constructionData
  );
  const [deliveryConditions, setDeliveryConditions] = useState(
    constructionRegistrationState.deliveryConditions ||
      DEFAULT_DELIVERY_CONDITIONS
  );
  const [responsiblesOfConstruction, setResponsiblesOfConstruction] = useState(
    constructionRegistrationState.responsiblesOfConstruction || [
      DEFAULT_RESPONSIBLE_OF_CONSTRUCTION
    ]
  );

  const goToConstructionsHome = () => {
    history.push(`${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}`);
  };

  const updateConstructionRegistrationState = () => {
    if (
      !pathname.includes(EConstructionRegistrationRoutes.CONSTRUCTION_DATA) &&
      !pathname.includes(EConstructionRegistrationRoutes.CHECKOUT) &&
      !pathname.includes(EConstructionRegistrationRoutes.SUCCESS)
    ) {
      dispatch(
        updateConstructionRegistrationSettings({
          ...constructionRegistrationState,
          constructionData,
          deliveryConditions,
          responsiblesOfConstruction
        })
      );
    }
  };

  // dispara ação de atualizar estado quando trocar de página
  useEffect(() => {
    const unlisten = history.listen(() => {
      updateConstructionRegistrationState();
    });

    return () => {
      unlisten();
    };
  });

  useEffect(() => {
    if (!constructionRegistrationState.contractNumber) {
      goToConstructionsHome();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <ConstructionHeader>
        <GoBackButton title="Voltar" onClick={goToConstructionsHome} />

        {pathname.includes(EConstructionRegistrationRoutes.SUCCESS) && (
          <header>
            <Title level={1}>Solicitação de corte e dobra</Title>
          </header>
        )}

        {!pathname.includes(EConstructionRegistrationRoutes.SUCCESS) && (
          <>
            <Title level={1}>Cadastro de obra</Title>
            <ConstructionRegistrationTabs />
          </>
        )}
      </ConstructionHeader>

      <ConstructionRegistrationRoutes
        constructionRegistration={constructionRegistrationState}
        constructionData={constructionData}
        setConstructionData={setConstructionData}
        deliveryConditions={deliveryConditions}
        setDeliveryConditions={setDeliveryConditions}
        responsiblesOfConstruction={responsiblesOfConstruction}
        setResponsiblesOfConstruction={setResponsiblesOfConstruction}
      />
    </div>
  );
};

export default ConstructionRegistration;
